import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { CurrentService } from '@portal-core/current/services/current.service';
import { AlertType } from '@portal-core/general/enums/alert-type.enum';
import { LicenseUserSeatType } from '@portal-core/license-users/enums/license-user-seat-type.enum';
import { Observable, first, map, tap } from 'rxjs';

export const authorAccessResolver: ResolveFn<boolean> = (): Observable<boolean> => {
  const router = inject(Router);
  const currentService = inject(CurrentService);

  return currentService.getLicenseUser$().pipe(
    first(licenseUser => !!licenseUser),
    map(licenseUser => licenseUser.SeatType === LicenseUserSeatType.Author),
    tap(accessAllowed => {
      if (!accessAllowed) {
        router.navigate(['/alert'], { queryParams: { type: AlertType.UserLicenseAccessDenied } });
      }
    })
  );
};
